
import { useState } from 'react';

function Contact() {
    // usestate
    const form = document.getElementById("form")
    const form2 = document.getElementById('form2')
    const main = document.getElementsByTagName('main')[0];
    const [user, setUser] = useState({
        fname: "", femail: "", fmsg: ""
    });


    const handleInputs = (e) => {
        const { name, value } = e.target;
        setUser((prevUser) => ({ ...prevUser, [name]: value }));
    };

    const PostData = async (e) => {

        e.preventDefault();

        const { fname, femail, fmsg } = user;
        const res = await fetch("http://localhost:5001/submit", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                fname: fname, femail: femail, fmsg: fmsg
            })
        });
        await res.json();
        if (res.ok) {
            form.style.display = 'none';
            form2.style.display = 'flex';
            main.style.margin = "200px 0 250px 0";
        } else {
            console.error("Error in response:", res.statusText);
        }


    }

    return (
        <main className='contact-main'>
            <div className="formdiv">
                <form method="POST" >
                    <h1 className="formh1">Contact Us</h1>
                    <div id="form">
                        <p >Let us know how we can help you and our team will be in touch as soon as possible!</p>
                        <div className="formdesign" id="name">
                            <input type="text" name="fname" required placeholder="Your Name" className="place" onChange={handleInputs} /><b><span
                                className="formerror"></span></b>
                        </div>
                        <div className="formdesign" id="email">
                            <input type="email" name="femail" required placeholder="Email" className="place" onChange={handleInputs} /> <b><span
                                className="formerror"></span></b>
                        </div>
                        <div className="formdesign" id="msg">
                            <textarea name="fmsg" required placeholder="Message" className="place " onChange={handleInputs} /> <b><span
                                className="formerror"></span></b>
                        </div>
                        <button className="contact-but but" type="submit" value="Send Message" onClick={PostData}>Send Message</button>
                    </div>
                    <div id="form2">
                        Let us know how we can help you and our team will be in touch as soon as possible!
                    </div>
                </form>

            </div>


        </main>
    )
}

export default Contact;



